import React from "react";
import { useLocation } from "react-router-dom";
import Logo from "../../typography/img/logo.png";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Asidebar = ({ isActivated }) => {
  const location = useLocation();
  const { pathname } = location;
  const userRole = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).userRole;
  const customer = useSelector((state) => state.user.users[0]);
  const user = customer;

  const pagesWithDropdown1 = ["/dashboard", "/superadmin"];
  const pagesWithDropdown2 = ["/manage-customer", "/basic-detail"];
  const pagesWithDropdown3 = [
    "/ebasic-detail",
    "/subscription",
    "/invoice",
    "/payment-method",
    "/user-management",
    "/setting",
    "/ebilling-detail",
    "/ebranding",
    "/edit-user",
    "/add-user",
  ];
  const pagesWithDropdown4 = ["/panel-management", "/profiling-questions", "/addquestions", "/edit-questions"];
  const pagesWithDropdownSurvey = ["/survey-listing", "/survey-programming", "/add-quota", "/view-quota",];

  const showDropdown1 = pagesWithDropdown1.includes(pathname);
  const showDropdown2 = pagesWithDropdown2.includes(pathname);
  const showDropdown3 = pagesWithDropdown3.includes(pathname);
  const showDropdown4 = pagesWithDropdown4.includes(pathname);
  const showDropdownSurvey = pagesWithDropdownSurvey.includes(pathname);

  return (
    <aside
      id="aside_menu"
      className={
        isActivated
          ? "activated bg-white border-end border-light-subtle"
          : "bg-white border-end border-light-subtle"
      }
    >
      <div className="p-4 ">
        <div className="logo">
          <img src={Logo} width="114px" className="img-fluid" alt="" />
        </div>

        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid p-0">
            <div className="mt-4" id="navbarNav">
              <ul className="navbar-nav flex-column">
                <li className="nav-item">
                  <a
                    className="nav-link toggle-sub-dropdown"
                    data-bs-toggle="collapse"
                    href="#Dashboard"
                    role="button"
                    aria-expanded="false"
                    aria-controls=""
                  >
                    <i className="bi bi-speedometer2"></i> Dashboard
                    <i className="bi bi-chevron-down"></i>
                  </a>
                  <ul
                    className={`sub-dropdown collapse ${showDropdown1 ? "show" : ""
                      } `}
                    id="Dashboard"
                  >
                    <li className={pathname === "/dashboard" ? "active" : ""}>
                      <Link to="/dashboard"> Dashboard</Link>
                    </li>
                    <li className={pathname === "/superadmin" ? "active" : ""}>
                      <Link to="/superadmin"> SuperAdmin</Link>
                    </li>

                  </ul>
                </li>

                {userRole === "S" ? (
                  <li className="nav-item">
                    <a
                      className="nav-link toggle-sub-dropdown"
                      data-bs-toggle="collapse"
                      href="#ManageCustomer"
                      role="button"
                      aria-expanded="false"
                      aria-controls=""
                    >
                      <i className="bi bi-people"></i> Customer
                      <i className="bi bi-chevron-down"></i>
                    </a>
                    <ul
                      className={`sub-dropdown collapse ${showDropdown2 ? "show" : ""
                        }`}
                      id="ManageCustomer"
                    >
                      <li
                        className={
                          pathname === "/manage-customer" ? "active" : ""
                        }
                      >
                        <Link to="/manage-customer">Manage Customer</Link>
                      </li>
                    </ul>
                  </li>
                ) : (
                  ""
                )}

                {/* Survey Dropdown */}
                <li className="nav-item">
                  <a
                    className={`nav-link toggle-sub-dropdown ${userRole === "S" && !user ? "disabled" : ""
                      }`}
                    data-bs-toggle="collapse"
                    href="#Survey"
                    role="button"
                    aria-expanded="false"
                    aria-controls=""
                  >
                    <i className="bi bi-file-earmark-text"></i> Survey
                    <i className="bi bi-chevron-down"></i>
                  </a>
                  <ul
                    className={`sub-dropdown collapse ${showDropdownSurvey ? "show" : ""
                      }`}
                    id="Survey"
                  >
                    <li
                      className={
                        pathname === "/survey-listing" ? "active" : ""
                      }
                    >
                      <Link to="/survey-listing">Survey Listing</Link>
                    </li>
                    <li
                      className={
                        pathname === "/survey-programming" ? "active" : ""
                      }
                    >
                      <Link to="/survey-programming">Survey Programming</Link>
                    </li>
                    <li className={pathname === "/add-quota" ? "active" : ""}>
                      <Link to="/add-quota">Add Quota</Link>
                    </li>
                    <li className={pathname === "/view-quota" ? "active" : ""}>
                      <Link to="/view-quota">View Quota</Link>
                    </li>
                  </ul>
                </li>

                <li className={`nav-item `}>
                  <a
                    className={`nav-link toggle-sub-dropdown ${userRole === "S" && !user ? "disabled" : ""
                      }`}
                    data-bs-toggle="collapse"
                    href="#Account"
                    role="button"
                    aria-expanded="false"
                    aria-controls=""
                  >
                    <i className="bi bi-people"></i>Admin
                    <i className="bi bi-chevron-down"></i>
                  </a>
                  <ul
                    className={`sub-dropdown collapse ${showDropdown3 ? "show" : ""
                      }`}
                    id="Account"
                  >
                    <li
                      className={pathname === "/ebasic-detail" ? "active" : ""}
                    >
                      <Link to="/ebasic-detail">Account Details</Link>
                    </li>
                    <li
                      className={pathname === "/subscription" ? "active" : ""}
                    >
                      <Link to="/subscription">Subscription</Link>
                    </li>
                    <li className={pathname === "/invoice" ? "active" : ""}>
                      <Link to="/invoice">Invoices</Link>
                    </li>
                    <li
                      className={
                        pathname === "/payment-method" ? "active" : ""
                      }
                    >
                      <Link to="/payment-method">Payment method</Link>
                    </li>
                    <li
                      className={
                        pathname === "/user-management" ? "active" : ""
                      }
                    >
                      <Link to="/user-management">User management</Link>
                    </li>
                    <li className={pathname === "/setting" ? "active" : ""}>
                      <Link to="/setting">Account setting</Link>
                    </li>
                  </ul>
                </li>

                <li className="nav-item">
                  <a
                    className={`nav-link toggle-sub-dropdown ${userRole === "S" && !user ? "disabled" : ""
                      }`}
                    data-bs-toggle="collapse"
                    href="#Profiling"
                    role="button"
                    aria-expanded="false"
                    aria-controls=""
                  >
                    <i className="bi bi-cash-stack"></i> Profiling
                    <i className="bi bi-chevron-down"></i>
                  </a>
                  <ul
                    className={`sub-dropdown collapse ${showDropdown4 ? "show" : ""
                      }`}
                    id="Profiling"
                  >
                    <li
                      className={
                        pathname === "/panel-management" ? "active" : ""
                      }
                    >
                      <Link to="/panel-management">Panel Management</Link>
                    </li>
                    <li
                      className={
                        pathname === "/profiling-questions" ? "active" : ""
                      }
                    >
                      <Link to="/profiling-questions">
                        Manage Profiling Questions
                      </Link>
                    </li>
                    <li>
                      <a href="#">Sub Service 3</a>
                    </li>
                  </ul>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link toggle-sub-dropdown"
                    data-bs-toggle="collapse"
                    href="#Authentication"
                    role="button"
                    aria-expanded="false"
                    aria-controls=""
                  >
                    <i className="bi bi-shield-lock"></i> Authentication{" "}
                    <i className="bi bi-chevron-down"></i>
                  </a>
                  <ul className="sub-dropdown collapse" id="Authentication">
                    <li>
                      <a href="#">Sub Service 1</a>
                    </li>
                    <li>
                      <a href="#">Sub Service 2</a>
                    </li>
                    <li>
                      <a href="#">Sub Service 3</a>
                    </li>
                  </ul>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link toggle-sub-dropdown"
                    data-bs-toggle="collapse"
                    href="#Integration"
                    role="button"
                    aria-expanded="false"
                    aria-controls=""
                  >
                    <i className="bi bi-key"></i> Integration{" "}
                    <i className="bi bi-chevron-down"></i>
                  </a>
                  <ul className="sub-dropdown collapse" id="Integration">
                    <li>
                      <a href="#">Sub Service 1</a>
                    </li>
                    <li>
                      <a href="#">Sub Service 2</a>
                    </li>
                    <li>
                      <a href="#">Sub Service 3</a>
                    </li>
                  </ul>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link toggle-sub-dropdown"
                    data-bs-toggle="collapse"
                    href="#Support"
                    role="button"
                    aria-expanded="false"
                    aria-controls=""
                  >
                    <i className="bi bi-person-badge"></i> Support
                    <i className="bi bi-chevron-down"></i>
                  </a>
                  <ul className="sub-dropdown collapse" id="Support">
                    <li>
                      <a href="#">Sub Service 1</a>
                    </li>
                    <li>
                      <a href="#">Sub Service 2</a>
                    </li>
                    <li>
                      <a href="#">Sub Service 3</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
      <div id="asidefooter">
        <hr className="m-0" />
        <div className="d-flex justify-content-center align-items-center gap-5 py-4">
          <a href="#">
            <i className="bi bi-brightness-high"></i>
          </a>
          <a href="#">
            <i className="bi bi-info-circle"></i>
          </a>
          <a href="#">
            <i className="bi bi-people"></i>
          </a>
        </div>
      </div>
    </aside>
  );
};

export default Asidebar;
